import { render, staticRenderFns } from "./homeButtonCube.vue?vue&type=template&id=28d00b14&scoped=true&"
import script from "./homeButtonCube.vue?vue&type=script&lang=js&"
export * from "./homeButtonCube.vue?vue&type=script&lang=js&"
import style0 from "./homeButtonCube.vue?vue&type=style&index=0&id=28d00b14&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28d00b14",
  null
  
)

export default component.exports